import styled, { AnyStyledComponent } from 'styled-components'
import ErrorIllustration from '../../../assets/icons/error-illustration.svg'

export const ErrorIllustrationIcon = styled(ErrorIllustration as AnyStyledComponent)`
    width: 9.3125rem;
    height: 4.3125rem;
`
